import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	Form,
	FormInput,
	FormButton,
	Margin,
	Text,
} from 'shared/components'

import * as styles from './styles'

const Step2FormComponent = ({
	form,
	onSubmitForm,
	onSkip,
	onBack,
	loadJurisdictions,
	getOptionLabel,
	getOptionValue,
}) => (
	<div css={styles.mobileContainer}>
		{/* Header with back arrow and title */}
		<div css={styles.header}>
			<FontAwesomeIcon
				icon="arrow-left"
				css={styles.backArrow}
				onClick={onBack}
			/>
			<div css={styles.headerContent}>
				<Text as="h1" css={styles.title}>
					Sign up
				</Text>
				<Text css={styles.stepIndicator}>
					Step 2/2
				</Text>
			</div>
		</div>

		{/* Form Content */}
		<div css={styles.formContainer}>
			<Margin bottom={3}>
				<Text css={styles.sectionTitle}>
					Additional Info:
				</Text>
			</Margin>

			<Form form={form} onSubmit={onSubmitForm}>
				<Margin bottom={3}>
					<div css={styles.countryInputContainer}>
						<div css={styles.inputWrapper}>
							<FormInput
								oldInput
								cacheOptions
								defaultOptions
								getOptionLabel={getOptionLabel}
								getOptionValue={getOptionValue}
								type="async-select"
								name="country"
								placeholder="Select your country"
								loadOptions={loadJurisdictions}
								error={form.errors?.country}
								fluid
								bordered
							/>
						</div>
					</div>
				</Margin>

				<Margin bottom={3}>
					<div css={styles.inputContainer}>
						<div css={styles.inputWrapper}>
							<FormInput
								name="postalCode"
								placeholder="Postal or ZIP code"
								error={form.errors?.postalCode}
							/>
						</div>
					</div>
				</Margin>

				<Margin bottom={3}>
					<div css={styles.inputContainer}>
						<div css={styles.inputWrapper}>
							<FormInput
								name="state"
								placeholder="Name of the state etc."
								error={form.errors?.state}
							/>
						</div>
					</div>
				</Margin>

				<Margin bottom={3}>
					<div css={styles.inputContainer}>
						<div css={styles.inputWrapper}>
							<FormInput
								name="city"
								placeholder="Name of the city or town"
								error={form.errors?.city}
							/>
						</div>
					</div>
				</Margin>

				<Margin bottom={3}>
					<div css={styles.inputContainer}>
						<div css={styles.inputWrapper}>
							<FormInput
								name="addressLine1"
								placeholder="Address Line 1"
								error={form.errors?.addressLine1}
							/>
						</div>
					</div>
				</Margin>

				<Margin bottom={4}>
					<div css={styles.inputContainer}>
						<div css={styles.inputWrapper}>
							<FormInput
								name="addressLine2"
								placeholder="Address Line 2"
								error={form.errors?.addressLine2}
							/>
						</div>
					</div>
				</Margin>

			</Form>
		</div>

		{/* Footer */}
		<div css={styles.footerContainer}>
			<Form form={form} onSubmit={onSubmitForm} css={styles.footerForm}>
				{/* Submit Button */}
				<div css={styles.buttonContainer}>
					<FormButton
						submit
						css={styles.submitButton}
					>
						<Text css={styles.buttonText}>
							Save and continue
						</Text>
					</FormButton>
				</div>
			</Form>

			{/* Skip Link */}
			<div css={styles.skipContainer}>
				<Text css={styles.skipText} onClick={onSkip}>
					Skip
				</Text>
			</div>

			{/* Progress Indicator */}
			<div css={styles.progressContainer}>
				<div css={styles.progressBar}></div>
			</div>
		</div>
	</div>
)

Step2FormComponent.propTypes = {
	form: PropTypes.shape().isRequired,
	onSubmitForm: PropTypes.func.isRequired,
	onSkip: PropTypes.func.isRequired,
	onBack: PropTypes.func.isRequired,
	loadJurisdictions: PropTypes.func.isRequired,
	getOptionLabel: PropTypes.func.isRequired,
	getOptionValue: PropTypes.func.isRequired,
}

export default Step2FormComponent 